declare global {
  interface String {
    capitalize(): string;
    camelCaseToSpaces(): string;
    camelCaseToKebabCase(): string;
    replaceAll(searchValue: string, replacementValue: string): string;
  }
}
String.prototype.capitalize = function () {
  if (!this) return this;
  return `${this[0].toUpperCase()}${this.substring(1)}`;
};

String.prototype.camelCaseToSpaces = function () {
  return this.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/^./, (char) =>
    char.toUpperCase()
  );
};

String.prototype.camelCaseToKebabCase = function () {
  return this.replace(/([a-z])([A-Z])/g, "$1-$2")
    .replaceAll(" ", "-")
    .toLowerCase();
};

String.prototype.replaceAll = function (
  searchValue: string,
  replacementValue: string
) {
  return this.split(searchValue).join(replacementValue);
};
